const GENDER_DISPLAY_MAP: Record<string, string> = {
  Men: "Male",
  Women: "Female",
};

export const formatGenderLabel = (gender?: string | null): string => {
  if (!gender) {
    return "—";
  }

  return GENDER_DISPLAY_MAP[gender] ?? gender;
};
